import EventHandler from '@pixelunion/events';
import { transition } from '@pixelunion/animations';
import {
  trapFocus,
  removeTrapFocus,
} from '@shopify/theme-a11y';

export default class NavMobileSubmenu {
  constructor(settings) {
    this.menu = settings.submenu;
    this.trigger = settings.trigger;
    this.parentMenu = settings.parentMenu;
    this.tier = settings.tier;
    this.submenu = null;

    this.backButton = this.menu.querySelector('[data-mobile-back-button]');
    this.flyout = this.menu.querySelector('[data-mobile-submenu-flyout]');
    this.overlay = this.menu.querySelector('[data-mobile-submenu-overlay]');
    this.submenuTriggers = this.menu.querySelectorAll(`[data-mobile-submenu-button="tier-${this.tier}"]`);

    this.events = new EventHandler();

    this.flyoutAnimation = transition({ el: this.flyout, state: 'closed' });
    this.overlayAnimation = transition({ el: this.overlay, state: 'closed' });

    this.events.register(this.backButton, 'click', () => this.close());

    this.submenuTriggers.forEach(submenuTrigger => {
      this.events.register(submenuTrigger, 'click', e => this.openSubmenu(e));
    });

    this.open();
  }

  open() {
    this.menu.dataset.open = true;
    this.flyoutAnimation.animateTo('open');
    this.overlayAnimation.animateTo('open');

    this.menu.focus();
    trapFocus(this.menu);
  }

  close() {
    removeTrapFocus(this.menu);
    this.trigger.focus();
    trapFocus(this.parentMenu);

    this.parentMenu.dataset.childOpen = false;

    this.overlayAnimation.animateTo('closed');
    this.flyoutAnimation.animateTo('closed')
      .then(() => {
        this.unload();
      });
  }

  openSubmenu(e) {
    const submenuTrigger = e.target;
    const submenu = submenuTrigger.nextElementSibling;

    this.menu.dataset.childOpen = true;

    this.submenu = new NavMobileSubmenu({
      submenu,
      trigger: submenuTrigger,
      parentMenu: this.menu,
      tier: this.tier + 1,
    });
  }

  unload() {
    if (this.submenu) {
      this.submenu.unload();
    }

    this.menu.dataset.open = false;
    this.menu.dataset.childOpen = false;

    this.flyoutAnimation.animateTo('closed', { force: true });
    this.overlayAnimation.animateTo('closed', { force: true });

    this.flyoutAnimation.unload();
    this.overlayAnimation.unload();
    this.events.unregisterAll();
  }
}
